import { Link, Text, Container, Flex, Stack, Grid } from 'basis';
import styled from '@emotion/styled';
import { useTrackingEvent } from 'hooks';
import { AuFooterLogo } from 'components/logo/au/AuLogo';

const footerLinks = {
  privacy_policy: {
    label: 'Privacy and Credit Reporting Policy',
    url: 'https://www.latitudefinancial.com.au/privacy',
  },
  terms_and_conditions: {
    label: 'Website Terms and Conditions',
    url: 'https://www.latitudefinancial.com.au/terms-and-conditions',
  },
  security: {
    label: 'Security',
    url: 'https://www.latitudefinancial.com.au/security',
  },
};

type FooterLinkKey = keyof typeof footerLinks;

export const FooterWrapper = styled.div`
  background-color: var(--Indigo-1000, #0b2374);

  & div {
    background-color: var(--Indigo-1000, #0b2374);
  }

  margin: 0 auto;

  svg {
    height: 24px;
    min-width: 150px;
  }
  @media (min-width: 992px) {
    & > div {
      display: flex;
    }
  }

  @media (min-width: 768px) {
    svg {
      height: 32px;
      width: 204px;
    }
  }
`;

const LinkWrapper = styled.div`
  span {
    color: white;
    text-decoration: underline;
  }

  span:hover {
    background: inherit;
  }
`;

export function AuFooter() {
  const { trackEvent, getQueryString } = useTrackingEvent();

  const trackEventSender = (label: string) => {
    trackEvent({
      category: 'text-link',
      action: 'internal-link',
      location: 'footer',
      label,
    });
  };

  const getLinkWithAnalytics = (key: FooterLinkKey) => {
    const gemid2 = getQueryString({
      category: 'text-link',
      action: 'internal-link',
      location: 'footer',
      label: footerLinks[key].label,
    });

    const link = new URL(footerLinks[key].url);
    link.searchParams.set('gemid2', gemid2);
    return link.href;
  };

  return (
    <Container testId="au-card-footer">
      <FooterWrapper>
        <Container padding="5 4">
          <Container margin="auto" margin-md="auto">
            <Grid colsGutter="0" cols="6">
              <Grid.Item colSpan="0-1" colSpan-md="0" colSpan-lg="0" rowSpan="0" rowSpan-md="0" margin-md="0">
                <Container padding="6 0" padding-md="0 0 5 0">
                  <Flex placeItems="center left">
                    <AuFooterLogo />
                  </Flex>
                </Container>
              </Grid.Item>

              <Grid.Item colSpan="all">
                <Flex placeItems="left">
                  <Stack direction="horizontal" align="left" gap="3 4">
                    {Object.keys(footerLinks).map((key, index) => {
                      return (
                        <LinkWrapper>
                          <Link
                            variant="medium-bg"
                            key={index}
                            href={getLinkWithAnalytics(key as FooterLinkKey)}
                            newTab
                            onClick={() => trackEventSender(footerLinks[key as FooterLinkKey].label)}
                          >
                            {footerLinks[key as FooterLinkKey].label}
                          </Link>
                        </LinkWrapper>
                      );
                    })}
                  </Stack>
                </Flex>
              </Grid.Item>

              <Grid.Item colSpan="all">
                <Flex placeItems="left">
                  <Container textStyle="legal" margin="7 0 0 0">
                    <Text color="white">
                      Credit facility provided by Latitude Finance Australia ABN 42 008 583 588. Australian Credit
                      Licence Number 392145. 130 Lonsdale Street, Melbourne 3000.
                    </Text>
                  </Container>
                </Flex>
              </Grid.Item>
            </Grid>
          </Container>
        </Container>
      </FooterWrapper>
    </Container>
  );
}
